import _ from "lodash"

export function mergeToDefaultData<T>(createDefaultData:()=>T,data?:Partial<T>):T{
    // const res = _.mergeWith(createDefaultData(),data, (a,b)=>{
    //     if(_.isArray(a) && _.isArray(b)){
    //         return b
    //     }
    // })
    // return res
    return mergeDataWith(createDefaultData(),data)
}

export function mergeDataWith<T>(dist:T, src?:Partial<T>){
    return _.mergeWith(dist, src, (a,b)=>{
        if(_.isArray(a) && _.isArray(b)){
            return b
        }
    })
}
export function createMergeToDefaultData<T>(createDefaultData:()=>T){
    return (data?:Partial<T>)=>mergeToDefaultData(createDefaultData,data)
}

